import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) return null;

  const breadcrumbItems = [
    { label: 'ホーム', url: '/' },
    ...items
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.url ? { item: `https://billwave.jp${item.url}` } : {})
    }))
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <nav 
        aria-label="パンくずリスト" 
        style={{ 
          width: '100%', 
          maxWidth: '100%', 
          backgroundColor: '#f9fafb', 
          padding: '10px 16px', 
          border: 'none', 
          borderRadius: '0.375rem', 
          marginBottom: '1.5rem',
          boxSizing: 'border-box'
        }}
        className="text-sm text-gray-600"
      >
        <ol 
          style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            alignItems: 'center', 
            margin: 0, 
            padding: 0, 
            listStyle: 'none',
            gap: '0.5rem'
          }}
        >
          {breadcrumbItems.map((item, index) => {
            const isLast = index === breadcrumbItems.length - 1;
            return (
              <li 
                key={index} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  margin: 0, 
                  padding: 0, 
                  border: 'none',
                  gap: '0.5rem'
                }}
              >
                {index > 0 && <ChevronRight className="w-4 h-4 text-gray-400 shrink-0" />}
                {index === 0 && <Home className="w-4 h-4 mr-1 text-gray-500 inline shrink-0" />}
                {isLast || !item.url ? (
                  <span className="font-semibold text-gray-800 whitespace-nowrap" aria-current="page">
                    {item.label}
                  </span>
                ) : (
                  <Link to={item.url} className="hover:text-blue-600 hover:underline whitespace-nowrap">
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
